var map = {
	"./C-logo.png": 8698,
	"./CPP-logo.png": 5506,
	"./CSS3-logo.png": 9247,
	"./Express.png": 7751,
	"./Git.png": 7923,
	"./Github.png": 1430,
	"./JavaScript-logo.png": 9156,
	"./Python-logo.png": 9317,
	"./React.png": 3238,
	"./Sau.png": 4902,
	"./Tailwind.png": 9363,
	"./bootstrap-logo.png": 9745,
	"./html5-logo.png": 4875,
	"./java-logo.svg": 7235,
	"./linux.png": 3177,
	"./myntra.png": 5564,
	"./nodejs-logo.svg": 4668,
	"./paint app.png": 9518,
	"./rnw-logo.png": 174,
	"./rnwlogo.png": 9645,
	"./shopbay.png": 115,
	"./vscode-logo.png": 3837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;